import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntrySingleLine } from '../settings-entry';
import { h } from 'vue';
import { FormRange } from '@components/form';
import svg from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/zoom_speed.svg';

export const ZoomSpeedIcon = svg;

export function ZoomSensitivity() {
    return SettingsEntrySingleLine(
        'Zoom sensitivity',

        '',

        img(svg, 'Zoom sensitivity'),

        h(FormRange, {
            min: 0.01,
            max: 0.2,
            step: 0.01,
            value: app.settings.zoom_speed,
            'onUpdate:value': x => app.settings.zoom_speed = x,
            percentage: true,
            labels: [
                { value: 0.05, label: 'Slow' },
                { value: 1, label: 'Fast' },
            ],
        }),
    );
}
